import classNames from 'classnames';
import './Ribbon.scss';

export const Ribbon = ({
    text = '#1 Best Seller',
    horizontal = false,
}) => (
    <div className={classNames('ribbon', { 'is-horizontal': horizontal })}>{text}</div>
);